import { SVGProps } from './types';

const CheckedGreenBackgroundSquare = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
  >
    <path
      fill="#ECFDF3"
      d="M0 10C0 4.477 4.477 0 10 0h28c5.523 0 10 4.477 10 10v28c0 5.523-4.477 10-10 10H10C4.477 48 0 43.523 0 38z"
    ></path>
    <path
      stroke="#079455"
      strokeLinecap="square"
      strokeWidth="1.75"
      d="m19.5 24 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z"
    ></path>
  </svg>
);

export { CheckedGreenBackgroundSquare };
